/**
 *  ┌──────────────────────────┐
 *  │  Did the user set their  │ No
 *  │                          ├────────►   Go to initial-settings view
 *  │  language and password?  │
 *  └────────────┬─────────────┘
 *               │ Yes
 *  ┌────────────▼─────────────┐
 *  │    Did the user accept   │ No
 *  │                          ├────────►  Go to data-policy view
 *  │     the data policy?     │
 *  └────────────┬─────────────┘
 *               │ Yes
 *  ┌────────────▼─────────────┐
 *  │     Is there an assign   │ Yes
 *  │                          ├────────►  window.location.assign to the the page in assign parameter
 *  │   parameter in the url?  │
 *  └────────────┬─────────────┘
 *               │ No
 *  ┌────────────▼─────────────┐
 *  │    Is there a redirect   │ Yes
 *  │                          ├────────►  Go the the page in redirect parameter
 *  │   parameter in the url?  │
 *  └────────────┬─────────────┘
 *               │ No
 *  ┌────────────▼─────────────┐
 *  │  Is the default entry    │ No
 *  │                          ├────────►  Go to the home page
 *  │     point defined?       │
 *  └────────────┬─────────────┘
 *               │ Yes
 *  ┌────────────▼─────────────┐ No
 *  │  Is it an external URL?  ├────────►  Use the router to go to that URL
 *  └────────────┬─────────────┘
 *               │ Yes
 *               ▼
 *      Use location.assign to
 *          go to that URL
 */

export function forwardToNextPage({
    assign,
    entryPoint,
    locationAssign = window.location.assign.bind(window.location),
    loginSteps = {},
    redirect,
    router,
}) {
    const { language, password, dataPolicy } = loginSteps

    if (language || password) {
        router.push({
            name: "initial-setup",
            query: { redirect },
        })
    } else if (dataPolicy) {
        router.push({
            name: "data-policy",
            query: { redirect },
        })
    } else if (assign) {
        locationAssign(assign)
    } else if (redirect) {
        try {
            router.push(redirect)
        } catch (_) {
            // The redirection throws an error if some navigationGuard detects the user doesn't have access to that page
        }
    } else if (entryPoint) {
        if (entryPoint.isExternal) {
            locationAssign(entryPoint.url)
        } else {
            router.push(entryPoint.url)
        }
    } else {
        router.push({ name: "home" })
    }
}

/**
 * Calculate the query based on "assign" & "redirect"
 * so that we do not include them if they are empty.
 */
export function getQuery({ assign, redirect }) {
    const query = {}
    if (assign) {
        query.assign = assign
    }
    if (redirect) {
        query.redirect = redirect
    }
    return query
}
